import type { SelectOption, SelectProps } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import map from 'lodash/map'
import { OrderDeliveryConfirmation } from '@ztechapps/order.common'
import find from 'lodash/find'
import type { SingleValue } from 'react-select'

export const options: SelectOption[] = map(OrderDeliveryConfirmation, (item) => {
  return { label: item.value, value: item.value }
})

export const DeliveryConfirmationSelect = ({ value, ...props }: SelectProps) => {
  const lookupValue = find(options, (e) => e.value === (value as SingleValue<SelectOption>).value)

  return <Select isClearable={false} options={options} value={lookupValue} {...props} />
}
